module.exports = __webpack_public_path__ + "fonts/OpenSans-LightItalic.77f11083.ttf";